const objFunc = () => {
  return {
    offers: [],
    unviewedOffersCount: 0
  }
}

export default objFunc()

export const defaultObj = objFunc()
